let isHoverContentVisible = false;
let isCustomCursorActive = false;
let isAddToBagActive = false; 

window.showCustomCursor = function(e) {
  if (window.isMobileView()) {
    return;
  }
  document.body.classList.add('custom-cursor-active');
  const customCursor = document.getElementById('custom-cursor');
  if (customCursor) {
    customCursor.style.display = 'flex';
    window.updateCustomCursorPosition(e);
  }
  isCustomCursorActive = true;

  // カーソルが表示された後、mousemoveイベントリスナーを追加
  document.addEventListener('mousemove', window.updateCustomCursorPosition);
};

window.hideCustomCursor = function() {
  document.body.classList.remove('custom-cursor-active');
  const customCursor = document.getElementById('custom-cursor');
  if (customCursor) {
    customCursor.style.display = 'none';
  }
  isCustomCursorActive = false;

  // カーソルが非表示になったら、mousemoveイベントリスナーを削除
  document.removeEventListener('mousemove', window.updateCustomCursorPosition);
};

window.updateCustomCursorPosition = function(e) {
  const customCursor = document.getElementById('custom-cursor');
  if (customCursor) {
    customCursor.style.left = `${e.clientX - 25}px`;
    customCursor.style.top = `${e.clientY - 25}px`;
  }
};

window.showCartArea = function() {
  const hoverContentArea = document.getElementById('js-hover-content-area');
  const cartContent = document.querySelector('.js-hover-content[data-content="cart"]');
  
  if (hoverContentArea) {
    hoverContentArea.classList.add('active');
    
    const contents = hoverContentArea.querySelectorAll('.js-hover-content');
    contents.forEach(content => {
      if (content.getAttribute('data-content') === 'cart') {
        content.style.display = 'block';
      } else {
        content.style.display = 'none';
      }
    });
  }

  document.body.style.overflow = 'hidden';
  window.showOverlayFilter();
  isHoverContentVisible = true;
  isCustomCursorActive = true;
  isAddToBagActive = true; // フラグを設定
};

window.isMobileView = function() {
  return window.innerWidth < 900;
};

window.updateOverlayFilter = function() {
  const overlayFilter = document.getElementById('overlay-filter');
  if (overlayFilter) {
    if (window.isMobileView()) {
      overlayFilter.style.backgroundColor = 'rgba(0, 0, 0, 0.25)';
    } else {
      overlayFilter.style.backgroundColor = 'transparent';
    }
  }
};

window.showOverlayFilter = function() {
  const overlayFilter = document.getElementById('overlay-filter');
  if (overlayFilter) {
    overlayFilter.style.display = 'block';
    window.updateOverlayFilter();
  }
};

// バンドル追加機能
async function handleBundleAddToCart(event) {
  const button = event.currentTarget;
  const bundleId = button.dataset.bundleId;

  // Get the selected variant of the main product
  const selectedVariantId = document.querySelector('input[name="id"]').value;

  try {
    // Add both products to cart
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          // {
          //   id: selectedVariantId,
          //   quantity: 1
          // },
          {
            id: bundleId,
            quantity: 1
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error('Failed to add products to cart');
    }
    
    // Update cart display
    if (typeof window.CartUpdater !== 'undefined') {
      await window.CartUpdater.updateCartDisplay();
    }

    // Show cart area after updating the cart
    if (typeof window.showCartArea === 'function') {
      window.showCartArea();
    }

    // Show custom cursor
    if (!window.isMobileView()) {
      setTimeout(() => {
        window.showCustomCursor(event);
      }, 2000);
    }

  } catch (error) {
    console.error('Error adding products to cart:', error);
  }
}

// メイン処理
document.addEventListener('DOMContentLoaded', () => {
  const navArea = document.getElementById('js-nav-area');
  const hoverContentArea = document.getElementById('js-hover-content-area');
  const customCursor = document.getElementById('custom-cursor');
  const hamburgerMenu = document.querySelector('.hamburger-menu');
  let isHoverContentVisible = false;
  let activeMenuItem = null;

  // オーバーレイフィルターの生成
  const overlayFilter = document.createElement('div');
  overlayFilter.id = 'overlay-filter';
  overlayFilter.style.position = 'fixed';
  overlayFilter.style.top = '0';
  overlayFilter.style.left = '0';
  overlayFilter.style.width = '100%';
  overlayFilter.style.height = '100%';
  overlayFilter.style.zIndex = '2';
  overlayFilter.style.display = 'none';

  const header = document.querySelector('header');
  if (header) {
    header.insertBefore(overlayFilter, header.firstChild);
  }

  function hideOverlayFilter() {
    overlayFilter.style.display = 'none';
  }

  function setEventListeners() {
    if (window.isMobileView()) {
      navArea.removeEventListener('mouseover', handleNavInteraction);
      navArea.removeEventListener('mouseout', handleNavMouseOut);
      navArea.addEventListener('click', handleNavInteraction);
    } else {
      navArea.removeEventListener('click', handleNavInteraction);
      navArea.addEventListener('mouseover', handleNavInteraction);
      navArea.addEventListener('mouseout', handleNavMouseOut);
    }
    window.updateOverlayFilter();
  }

  // function handleQuickAddClick(event) {
  //   const hoverContentArea = document.getElementById('js-hover-content-area');
  //   const quickAddContent = document.querySelector('[data-content="quick-add"]');
    
  //   hoverContentArea.classList.add('active');
    
  //   const contents = hoverContentArea.querySelectorAll('.js-hover-content');
  //   contents.forEach(content => {
  //     if (content.getAttribute('data-content') === 'quick-add') {
  //       content.style.display = 'block';
  //     } else {
  //       content.style.display = 'none';
  //     }
  //   });
  
  //   document.body.style.overflow = 'hidden';
  // }
  
  // document.querySelectorAll('.js-quick-add-button').forEach(button => {
  //   button.addEventListener('click', handleQuickAddClick);
  // });

  function handleNavInteraction(e) {
    const target = e.target.closest('.original-nav-menu');
    if (target) {
      const hoverTarget = target.getAttribute('data-hover-target');
      
      if (hoverTarget === 'hamburger' && window.isMobileView()) {
        hamburgerMenu.classList.toggle('active');
        if (hamburgerMenu.classList.contains('active')) {
          showHoverContent(hoverTarget);
        } else {
          hideHoverContent();
        }
      } else {
        showHoverContent(hoverTarget);
        if (window.isMobileView()) {
          hamburgerMenu.classList.remove('active');
        }
      }
    }
  }

  function handleNavMouseOut(e) {
    const target = e.target.closest('.original-nav-menu');
    if (target && target !== activeMenuItem) {
      updateMenuItemStyle(target, false);
    }
  }

  function showHoverContent(target) {
    const contents = hoverContentArea.querySelectorAll('.js-hover-content');
    contents.forEach(content => {
      if (content.getAttribute('data-content') === target) {
        content.style.display = 'block';
      } else {
        content.style.display = 'none';
      }
    });

    window.showOverlayFilter();

    hoverContentArea.classList.add('active');
    overlayFilter.style.display = 'block';
    
    if (target === 'explore') {
      hoverContentArea.classList.add('explore');
    } else {
      hoverContentArea.classList.remove('explore');
    }
    
    if (target === 'hamburger') {
      hoverContentArea.classList.add('hamburger');
    } else {
      hoverContentArea.classList.remove('hamburger');
    }
    
    isHoverContentVisible = true;
    document.body.style.overflow = 'hidden';

    if (activeMenuItem) {
      updateMenuItemStyle(activeMenuItem, false);
    }
    activeMenuItem = navArea.querySelector(`[data-hover-target="${target}"]`);
    updateMenuItemStyle(activeMenuItem, true);
  }

  // Make showHoverContent available globally for Yotpo reviews
  window.showHoverContent = showHoverContent;

  window.hideHoverContent = function() {
    const hoverContentArea = document.getElementById('js-hover-content-area');
    
    // すべてのjs-hover-content要素を非表示にする
    const contents = hoverContentArea.querySelectorAll('.js-hover-content');
    contents.forEach(content => {
      content.style.display = 'none';
    });
  
    hoverContentArea.classList.remove('active', 'explore', 'hamburger');
    document.body.style.overflow = '';
    hideOverlayFilter();
    isHoverContentVisible = false;
    isCustomCursorActive = false;
    isAddToBagActive = false; // フラグをリセット
    window.hideCustomCursor();
    overlayFilter.style.display = 'none';
    
    if (activeMenuItem) {
      updateMenuItemStyle(activeMenuItem, false);
      activeMenuItem = null;
    }
    
    hamburgerMenu.classList.remove('active');
  };

  function initCloseButtons() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.js-hover-content-close')) {
        window.hideHoverContent();
      }
    });
  }

  function updateMenuItemStyle(element, isActive) {
    if (['shop', 'explore'].includes(element.getAttribute('data-hover-target'))) {
      element.classList.toggle('active', isActive);
    } else {
      element.classList.toggle('hover', isActive);
      if (['search', 'account', 'cart'].includes(element.getAttribute('data-hover-target'))) {
        element.classList.toggle('active', isActive && isHoverContentVisible);
      }
    }
  }

  function isInsideNavWrapperOrContent(e) {
    const navWrapper = document.querySelector('.original-nav-wrapper');
    const navRect = navWrapper.getBoundingClientRect();
    const contentRect = hoverContentArea.getBoundingClientRect();
    
    return (e.clientX >= navRect.left && e.clientX <= navRect.right &&
            e.clientY >= navRect.top && e.clientY <= navRect.bottom) ||
           (e.clientX >= contentRect.left && e.clientX <= contentRect.right &&
            e.clientY >= contentRect.top && e.clientY <= contentRect.bottom);
  }

  window.showQuickAddCursor = function(e) {
    window.showCustomCursor(e);
    isHoverContentVisible = true;
    window.showOverlayFilter();
  };

  window.addEventListener('resize', setEventListeners);

  document.addEventListener('mousemove', (e) => {
    if (isAddToBagActive) {
      // カートに追加後の特殊な動作
      if (isInsideNavWrapperOrContent(e)) {
        window.hideCustomCursor();
      } else {
        window.showCustomCursor(e);
      }
    } else if (isCustomCursorActive || (isHoverContentVisible && !isInsideNavWrapperOrContent(e))) {
      // 通常の動作（変更なし）
      if (isInsideNavWrapperOrContent(e)) {
        window.hideCustomCursor();
      } else {
        window.showCustomCursor(e);
      }
    } else {
      window.hideCustomCursor();
    }
  });

  document.addEventListener('click', (e) => {
    if (isAddToBagActive && !isInsideNavWrapperOrContent(e)) {
      // カートに追加後の特殊なクリック動作
      e.preventDefault();
      e.stopPropagation();
      window.hideHoverContent();
      isAddToBagActive = false; // フラグをリセット
    } else if (isHoverContentVisible && !isInsideNavWrapperOrContent(e)) {
      // 通常のクリック動作（変更なし）
      e.preventDefault();
      e.stopPropagation();
      window.hideHoverContent();
    }
  }, true);

  document.addEventListener('wheel', (e) => {
    if (isHoverContentVisible && !isInsideNavWrapperOrContent(e)) {
      window.hideHoverContent();
    }
  });

  // 初期化
  setEventListeners();
  initCloseButtons();
  initHamburgerTabs();
  // バンドル追加ボタンのイベントリスナーを追加
  const bundleAddToCartButtons = document.querySelectorAll('.bundle-add-to-cart-btn');
  bundleAddToCartButtons.forEach(button => {
    button.addEventListener('click', handleBundleAddToCart);
  });
});

// カートに追加 関連の処理
window.handleAddToBag = async function(event) {
  const button = event.currentTarget;
  const buttonText = button.querySelector('.button-text');
  const spinner = button.querySelector('.loading-overlay__spinner');
  
  // ボタンを無効化し、スピナーを表示
  button.disabled = true;
  buttonText.style.opacity = '0';
  spinner.classList.remove('hidden');

  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) {
    console.error('Add to cart form not found');
    return;
  }

  const formData = new FormData(form);
  if (window.currentPreorderText) {
    formData.append('properties[Estimated Delivery]', window.currentPreorderText);
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    // フラグを設定
    isHoverContentVisible = true;
    isCustomCursorActive = true;
    isAddToBagActive = true;
    
    // カスタムカーソルを3秒後に表示
    if (!window.isMobileView()) {
      setTimeout(() => {
        window.showCustomCursor(event);
      }, 2000);
    }
    
    // CartUpdater を使用してカートを更新
    await window.CartUpdater.updateCartDisplay();
    
    // カートエリアを表示
    window.showCartArea();
    
    // カート数を更新
    window.CartUpdater.updateCartCount();

  } catch (error) {
    console.error('Error adding item to cart:', error);
  } finally {
    // ボタンを再有効化し、スピナーを非表示
    button.disabled = false;
    buttonText.style.opacity = '1';
    spinner.classList.add('hidden');
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const addToBagButtons = document.querySelectorAll('#custom-product-add-to-bag, .js-add-to-bag-button');
  addToBagButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      window.handleAddToBag(event);
    });
  });
});

// ハンバーガーメニューのタブ初期化
function initHamburgerTabs() {
  const tabButtons = document.querySelectorAll('.hamburger-tab');
  const tabContents = document.querySelectorAll('.hamburger-tab-content');

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabName = button.getAttribute('data-tab');

      tabButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      tabContents.forEach(content => {
        if (content.getAttribute('data-content') === tabName) {
          content.classList.add('active');
        } else {
          content.classList.remove('active');
        }
      });
    });
  });
}

// アコーディオン機能
const accordionButtons = document.querySelectorAll('.nav-shop__accordion-heading');
let openAccordion = null;

function closeAccordionElement(accordion) {
  if (accordion) {
    const body = accordion.nextElementSibling;
    body.style.height = '0';
    accordion.parentNode.classList.remove('open');
  }
}

function openAccordionElement(accordion) {
  const body = accordion.nextElementSibling;
  const text = body.children[0];
  const textHeight = text.offsetHeight;
  body.style.height = textHeight + 24 + 'px';
  accordion.parentNode.classList.add('open');
}

function toggleAccordion(clickedAccordion) {
  if (openAccordion && openAccordion !== clickedAccordion) {
    closeAccordionElement(openAccordion);
  }

  if (clickedAccordion.parentNode.classList.contains('open')) {
    closeAccordionElement(clickedAccordion);
    openAccordion = null;
  } else {
    openAccordionElement(clickedAccordion);
    openAccordion = clickedAccordion;
  }
}

accordionButtons.forEach((accordionButton) => {
  accordionButton.addEventListener('click', (e) => {
    const clickedAccordion = e.currentTarget;
    toggleAccordion(clickedAccordion);
  });
});

window.addEventListener('resize', window.updateOverlayFilter);